// 请求目标服务器域名配置
const DOMAIN_NAME = {
	URL_CNODEJS: 'https://service.sxsstem.cn', // 测试环境 http://120.55.57.35:13500
	// URL_CNODEJS: 'http://beta-science-server.sxsstem.cn', // 测试环境 http://120.55.57.35:13500
};


export default DOMAIN_NAME;
